import { useFeatureFlags } from '@hydra/common/components/FeatureFlags/featureFlagContext';
import { useI18n } from '@hydra/common/components/i18n';

export function useAuthenticationRoutes () {
  const featureFlags = useFeatureFlags();
  const { locale } = useI18n();
  const hydraAuth = featureFlags.hydraAuth;

  const signInFrontAction = `/${locale}/authenticate`; // Routed Front Action

  const signInRoute = `/${locale}/login`;

  const registerRoute = hydraAuth
    ? `/${locale}/authentication/register`
    : `/${locale}/signup`;

  const forgotPasswordRoute = `/${locale}/authentication/forgot-password`;

  const signOutRoute = `/${locale}/logout`;

  return {
    signInRoute,
    signOutRoute,
    registerRoute,
    forgotPasswordRoute,
    signInFrontAction
  };
}
